/* global axios */
import ApiClient from './ApiClient';

// "Casos" — agrupador de Processos relacionados. Ver
// .claude/specs/plans/casos-agrupador-processos.md.
class LegalCasesAPI extends ApiClient {
  constructor() {
    super('legal-cases', { accountScoped: true });
  }

  getAll(params = {}) {
    return axios.get(this.url, { params });
  }

  nextFolderNumber() {
    return axios.get(`${this.url}/next_folder_number`);
  }

  getById(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(params) {
    return axios.post(this.url, { legal_case: params });
  }

  update(id, params) {
    return axios.patch(`${this.url}/${id}`, { legal_case: params });
  }

  destroy(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new LegalCasesAPI();
